import { apiGet } from './api';

/** Notícia pública: identificada pelo slug (/news/<slug>); o id numérico não sai da API (dono 2026-10-22). */
export interface NewsItem {
  slug: string;
  title: string;
  subTitle?: string;
  image?: string | null;
  html: string;
  createdDate: string;
}

/** GET /Events/news — noticias (publico) */
export const getNews = () => apiGet<NewsItem[]>('/Events/news');

/** GET /Events/news/{slug} — uma noticia especifica (o id do link antigo /news/<id> ainda acha; a página troca pelo slug) */
export const getNewsBySlug = (slug: string) =>
  apiGet<NewsItem>(`/Events/news/${encodeURIComponent(slug)}`);
